/**
 * A 3D deep dive into DeepSeek V4-Pro: one token's trip through the model,
 * with its own soundtrack. three.js is big, so the player loads on its own,
 * only on pages that show it, and never on the server.
 */
import dynamic from "next/dynamic";

const Player = dynamic(() => import("./Player"), {
  ssr: false,
  loading: () => (
    <div className="not-prose my-10 relative left-1/2 -translate-x-1/2 w-[min(calc(100vw-2rem),64rem)] aspect-video rounded-xl border border-emerald-900/70 bg-black" />
  )
});

export default function DeepDive() {
  return <Player />;
}
